export const environment = {
  production: false,
  isBeta: false,
  FIREBASE_CONFIG: {
    apiKey: 'AIzaSyA1SiHN31BSpxiaNyt6lm3iZnuEZ6JVLTw',
    authDomain: 'racional-app-dev-qa.firebaseapp.com',
    databaseURL: 'https://racional-app-dev-qa.firebaseio.com',
    projectId: 'racional-app-dev-qa',
    storageBucket: 'racional-app-dev-qa.appspot.com',
    messagingSenderId: '1070952194829',
    appId: '1:1070952194829:web:f1830e6f2d9eac41c10644',
    measurementId: 'G-TJFH74TEBV',
  },
  cloudFunctionsBaseUrl: 'https://us-central1-racional-app-dev-qa.cloudfunctions.net',
  baseDeepLinkUrl: 'app.racional.cl',
  kushkiMerchantId: '3253fac4ab654d34ae6a2364343fe9ee',
  kushkiCallbackUrl: 'http://localhost:8100/tabs/home',
  partner: '',
  isPartnerSite: false,
  smartlookProjectKey: 'none',
  racionalStocksUrl: 'https://racional-stocks-api-pr7bgdokua-uc.a.run.app',
  withdrawalApiUrl: 'https://racional-withdrawals-api-1070952194829.us-central1.run.app',
  racionalDomain: 'https://racional-app-dev-qa.web.app',
  web2Url: 'https://beta.dev.racional.cl',
};
